import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { DatePipe, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
registerLocaleData(localeIt);

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { DataService } from './services/data.service';

// import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from './shared/shared.module';
import { HomePageComponent } from './home/home-page/home-page.component';
import { environment } from '../environments/environment';

// Firebase imports
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { AngularFireStorageModule, StorageBucket } from '@angular/fire/storage';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { OAuthModule } from 'angular-oauth2-oidc';
// import { StripeModule } from 'stripe-angular';
import { BillingPolicyPageComponent } from './home/billing-policy-page/billing-policy-page.component';
import { CoverageDialogComponent } from './dialogs/coverage-dialog.component';
import { TwoDigitDecimaNumberDirective } from './directives/two-digit-decima-number.directive';
import { ProviderDialogComponent } from './dialogs/practice/provider-dialog/provider-dialog.component';
import { InsuranceDialogComponent } from './dialogs/patient/insurance-dialog/insurance-dialog.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CareplanDialogComponent } from './dialogs/patient/careplan-dialog/careplan-dialog.component';
import { ClientContactDialogComponent } from './dialogs/practice/client-contact-dialog/client-contact-dialog.component';
import { CareteamDialogComponent } from './dialogs/patient/careteam-dialog/careteam-dialog.component';
import { AlertContactDialogComponent } from './dialogs/patient/alert-contact-dialog/alert-contact-dialog.component';
import { MeasureTypeDialogComponent } from './dialogs/patient/measure-type-dialog/measure-type-dialog.component';
import { CareplanProfileDialogComponent } from './dialogs/patient/careplan-profile-dialog/careplan-profile-dialog.component';
import { CareplanNewDialogComponent } from './dialogs/patient/careplan-new-dialog/careplan-new-dialog.component';
import { CaseItemDialogComponent } from './dialogs/patient/case-item-dialog/case-item-dialog.component';
import { DeviceOrderDialogComponent } from './dialogs/patient/device-order-dialog/device-order-dialog.component';
import { AuthInterceptor } from './services/auth/auth.interceptor';
import { BaaComponent } from './home/baa/baa.component';
import { PatientConsentDialogComponent } from './dialogs/practice/patient-consent-dialog/patient-consent-dialog.component';
import { VitalFlagDialogComponent } from './dialogs/patient/vital-flag-dialog/vital-flag-dialog.component';
import { DocumentDialogComponent } from './dialogs/patient/document-dialog/document-dialog.component';
import { PatientDemographicsDialogComponent } from './dialogs/patient/patient-demographics-dialog/patient-demographics-dialog.component';
import { ClientDemoDialogComponent } from './dialogs/admin/client-demo-dialog/client-demo-dialog.component';
import { SendBaaDialogComponent } from './dialogs/admin/send-baa-dialog/send-baa-dialog.component';
import { TrainingComponent } from './home/training/training.component';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    BillingPolicyPageComponent,
    CoverageDialogComponent,
    TwoDigitDecimaNumberDirective,
    ProviderDialogComponent,
    InsuranceDialogComponent,
    CareplanDialogComponent,
    ClientContactDialogComponent,
    CareteamDialogComponent,
    AlertContactDialogComponent,
    MeasureTypeDialogComponent,
    CareplanProfileDialogComponent,
    CareplanNewDialogComponent,
    CaseItemDialogComponent,
    DeviceOrderDialogComponent,
    BaaComponent,
    PatientConsentDialogComponent,
    VitalFlagDialogComponent, // deprecated
    DocumentDialogComponent,
    PatientDemographicsDialogComponent,
    ClientDemoDialogComponent,
    SendBaaDialogComponent,
    TrainingComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    FontAwesomeModule,
    OAuthModule.forRoot(),
    // StripeModule.forRoot(environment.stripeKey),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    DatePipe,
    DataService,
    { provide: StorageBucket, useValue: environment.storageBucket },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
